<script lang="ts" setup></script>
<template>
  <svg width="72" height="48" viewBox="0 0 72 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="59" height="48" rx="3" fill="currentColor" />
    <rect x="61" width="11" height="8" rx="2" fill="currentColor" />
    <rect x="61" y="10" width="11" height="8" rx="2" fill="currentColor" />
  </svg>
</template>
